(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.SenixManualsLibrary = api;
  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', api.init);
    } else {
      api.init();
    }
  }
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function normalize(record) {
    if (!record || typeof record !== 'object') return null;
    var sku = String(record.sku || '').trim();
    var category = String(record.category_handle || '').trim();
    var manualUrl = String(record.manual_url || '').trim();
    if (!sku || !category || !manualUrl) return null;
    return {
      sku: sku,
      title: String(record.title || sku).trim(),
      category: String(record.category || '').trim(),
      category_handle: category,
      manual_type: String(record.manual_type || '').trim(),
      manual_url: manualUrl,
      product_handle: String(record.product_handle || '').trim()
    };
  }

  function unique(records) {
    var seen = Object.create(null);
    return (records || []).map(normalize).filter(function (record) {
      if (!record) return false;
      var key = record.sku + '\n' + record.manual_url;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function filterRecords(records, query, category) {
    var needle = String(query || '').trim().toLowerCase();
    var categoryHandle = String(category || '').trim();
    return unique(records).filter(function (record) {
      var categoryMatch = !categoryHandle || record.category_handle === categoryHandle;
      var searchText = [record.sku, record.title, record.category, record.manual_type].join(' ').toLowerCase();
      return categoryMatch && (!needle || searchText.indexOf(needle) !== -1);
    });
  }

  function render(rootElement, records) {
    var grouped = Object.create(null);
    unique(records).forEach(function (record) {
      (grouped[record.category_handle] || (grouped[record.category_handle] = [])).push(record);
    });

    rootElement.querySelectorAll('[data-manual-category]').forEach(function (container) {
      var category = container.getAttribute('data-manual-category');
      var template = container.parentElement.querySelector('.senix-manual-link-template');
      container.textContent = '';
      (grouped[category] || []).forEach(function (record) {
        var fragment = template.content.cloneNode(true);
        var links = fragment.querySelectorAll('a');
        var text = fragment.querySelector('.text');
        text.textContent = record.title || record.sku;
        links.forEach(function (link) { link.href = record.manual_url; });
        links[1].setAttribute('aria-label', 'Download ' + record.sku + ' manual');
        fragment.firstElementChild.setAttribute('data-manual-sku', record.sku);
        fragment.firstElementChild.setAttribute('data-manual-url', record.manual_url);
        container.appendChild(fragment);
      });
    });
    rootElement.setAttribute('data-manual-library-status', 'ready');
    rootElement.dispatchEvent(new CustomEvent('senix:manual-library-ready', { detail: { count: unique(records).length } }));
  }

  function bindOptionalSearch(rootElement, records) {
    var search = rootElement.querySelector('[data-manual-search]');
    var filter = rootElement.querySelector('[data-manual-category-filter]');
    if (!search && !filter) return;
    function apply() {
      render(rootElement, filterRecords(records, search && search.value, filter && filter.value));
    }
    if (search) search.addEventListener('input', apply);
    if (filter) filter.addEventListener('change', apply);
  }

  function init() {
    document.querySelectorAll('[data-manual-library-root]').forEach(function (rootElement) {
      if (rootElement.getAttribute('data-manual-library-status')) return;
      rootElement.setAttribute('data-manual-library-status', 'loading');
      fetch(rootElement.getAttribute('data-manual-library-url'), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Manual library request failed: ' + response.status);
          return response.json();
        })
        .then(function (payload) {
          var records = unique(payload.records || payload);
          render(rootElement, records);
          bindOptionalSearch(rootElement, records);
        })
        .catch(function () {
          rootElement.setAttribute('data-manual-library-status', 'error');
        });
    });
  }

  return { normalize: normalize, unique: unique, filterRecords: filterRecords, render: render, init: init };
}));
